'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('contact-edit', {
      url: '/contact/edit/:id',
      template: '<contact-edit></contact-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/contact-edit/contact-edit.routes.js